import firebase from "@firebase/app"

export default{
    actions: {
        async createCategory({dispatch, commit}, {name, limit}){
            try{
                const uid = await dispatch('getUid');
                const category = await firebase.database().ref(`/users/${uid}/categories/`).push({name, limit});
                return {name, limit, id: category.key}
            } catch (e){
                commit('setError', e)
                throw e
            }
        },
        async getCategories({dispatch, commit}){
            try{
                const uid = await dispatch('getUid');
                const category = (await firebase.database().ref(`/users/${uid}/categories`).once('value')).val() || {};
                return Object.keys(category).map((id) => ({id, name: category[id].name, limit: category[id].limit}))
            } catch (e){
                commit('setError', e)
                throw e
            }
        },
        async updateCat({dispatch, commit}, {id, name, limit}){
            try{
                const uid = await dispatch('getUid');
                await firebase.database().ref(`/users/${uid}/categories/${id}/`).set({name, limit});
            } catch (e){
                commit('setError', e)
                throw e
            }
        },
        async getCategoryById({dispatch, commit}, id){
            try{
                const uid = await dispatch('getUid');
                const category = (await firebase.database().ref(`/users/${uid}/categories`).child(id).once('value')).val() || {};
                return { ...category, id }
            } catch (e){
                commit('setError', e);
                throw e;
            }
        }
    }
}